import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import { makeStyles } from '@mui/styles';
import TablePaginationActions from "@mui/material/TablePaginationActions";
import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { dateFormat, timeFormat } from "../../../util/DateUtil";
import { CircularProgress } from "@mui/material";
import Button from "../../UI/Button";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  cursorLink: {
    cursor: "pointer",
  },
  submit: {
    marginRight: "8px",
  },
  loadingRemove: {
    marginRight: "10px",
    marginLeft: "10px",
  },
});

const PresencaDisciplinaTable = ({
  presencas,
  handleChangePage,
  isLoadingRemove,
  handleDelete,
  setPresenca,
}) => {
  const classes = useStyles();

  return (
    <>
      <Button
        className={classes.novoRegistro}
        onClick={() => setPresenca({ eNovo: true })}
        variant="contained"
        color="primary"
      >
        Nova Presença
      </Button>
      <TablePagination
        rowsPerPageOptions={[]}
        rowsPerPage={presencas.size ? presencas.size : 0}
        component="div"
        count={presencas.totalElements}
        page={presencas.number}
        onPageChange={handleChangePage}
        labelDisplayedRows={({ from, to, count }) =>
          from +
          "-" +
          to +
          " de " +
          (count !== -1 ? count + " registros" : " mais de " + to)
        }
        ActionsComponent={TablePaginationActions}
      />
      <Table className={classes.table} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>Professor(a)</TableCell>
            <TableCell>Turma</TableCell>
            <TableCell>Data</TableCell>
            <TableCell>Cronograma Aula</TableCell>
            <TableCell>Ações</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {presencas.content.map((presenca, index) => (
            <TableRow key={presenca.codigo}>
              <TableCell>{presenca.tdp.usuario.nome}</TableCell>
              <TableCell>{presenca.tdp.turma.descricao}</TableCell>
              <TableCell>{dateFormat(presenca.data)}</TableCell>
              <TableCell>
                {presenca.cronograma &&
                  "Aula " +
                    presenca.cronograma.cronogramaAula.ordemAula +
                    " : " +
                    timeFormat(
                      presenca.cronograma.cronogramaAula.horarioInicio
                    ) +
                    " - " +
                    timeFormat(presenca.cronograma.cronogramaAula.horarioFim)}
              </TableCell>
              <TableCell>
                {isLoadingRemove ? (
                  <CircularProgress
                    className={classes.loadingRemove}
                    color="secondary"
                    size={20}
                  />
                ) : (
                  <DeleteIcon
                    fontSize="small"
                    className={classes.cursorLink}
                    onClick={() => {
                      handleDelete(presenca.codigo);
                    }}
                    style={{ marginRight: "10px" }}
                    color="secondary"
                  />
                )}
                <Button
                  variant="outlined"
                  size="small"
                  color="secondary"
                  onClick={() => setPresenca(presenca)}
                  className={classes.submit}
                >
                  Selecionar
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[]}
        rowsPerPage={presencas.size ? presencas.size : 0}
        component="div"
        count={presencas.totalElements}
        page={presencas.number}
        onPageChange={handleChangePage}
        labelDisplayedRows={({ from, to, count }) =>
          from +
          "-" +
          to +
          " de " +
          (count !== -1 ? count + " registros" : " mais de " + to)
        }
        ActionsComponent={TablePaginationActions}
      />
    </>
  );
};

export default PresencaDisciplinaTable;
